import { render, staticRenderFns } from "./loadingComponent.vue?vue&type=template&id=582b3691&scoped=true&"
import script from "./loadingComponent.vue?vue&type=script&lang=js&"
export * from "./loadingComponent.vue?vue&type=script&lang=js&"
import style0 from "./loadingComponent.vue?vue&type=style&index=0&id=582b3691&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b3691",
  null
  
)

export default component.exports